import { EmailPreferenceWrite } from './emailPreferenceWrite';

export class EmailPreference {
  readonly emailType: string;
  readonly description: string;
  readonly isReadOnly: boolean;

  private _isOptedIn: boolean;
  private _originalIsOptedIn: boolean;

  constructor(obj: IEmailPreference) {
    this._originalIsOptedIn = obj.isOptedIn;

    this.emailType = obj.emailType;
    this.description = obj.description;
    this.isOptedIn = obj.isOptedIn;
    this.isReadOnly = obj.isReadOnly;
  }

  get isOptedIn(): boolean {
    return this._isOptedIn;
  }

  set isOptedIn(value: boolean) {
    if (this.isReadOnly) {
      throw new Error('Cannot edit read-only value');
    }
    this._isOptedIn = value;
  }

  get isDirty(): boolean {
    return this.isOptedIn !== this._originalIsOptedIn;
  }

  get displayName(): string {
    const suffix = this.isReadOnly && this.isOptedIn ? ' (required)' : '';
    return this.description + suffix;
  }

  toEmailPreferenceWrite(): EmailPreferenceWrite {
    return {
      isOptedIn: this.isOptedIn,
    };
  }

  markClean(): void {
    this._originalIsOptedIn = this.isOptedIn;
  }
}

export interface IEmailPreference {
  emailType: string;
  description: string;
  isOptedIn: boolean;
  isReadOnly: boolean;
}
